/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import {
  getPAAmenities,
  selectActiveListings,
  selectImageIds,
  selectInactiveListings,
} from '@zcode-ui/perm-address'
import { getRouteProps } from '@zcode/nr/es/shared/packages/history-middleware'
import type { State } from '@zcode/state-type'
import { routes } from '@zcode/zumper-routes'

import { getTraktorPageType } from '../../../modules/traktor/thunks/trackDetailEvent'
import type { Dispatch } from '../../../modules/types'

export const getTrackingPAProps = (state: State, dispatch: Dispatch) => {
  const activeListings = selectActiveListings(state) ?? []
  const inactiveListings = selectInactiveListings(state) ?? []
  const allListings = activeListings.concat(inactiveListings)
  const visiblePropertyIds = activeListings.length
    ? activeListings.map((listing) => listing.listingId)
    : inactiveListings.map((listing) => listing.listingId)
  const amenities = getPAAmenities(allListings)
  const imageIds = selectImageIds(state)
  const imageCount = imageIds.length
  let minBeds: number | undefined
  let maxBeds: number | undefined
  let minBaths: number | undefined
  let maxBaths: number | undefined

  const activeListingsArr: number[] = []
  const inactiveListingsArr: number[] = []

  activeListings.map(({ listingId }) => {
    activeListingsArr.push(listingId)
  })

  inactiveListings.map(({ listingId }) => {
    inactiveListingsArr.push(listingId)
  })

  allListings.forEach(({ bedrooms, bathrooms }) => {
    if (typeof minBeds === 'undefined' || bedrooms < minBeds) {
      minBeds = bedrooms
    }
    if (typeof maxBeds === 'undefined' || bedrooms > maxBeds) {
      maxBeds = bedrooms
    }
    if (typeof minBaths === 'undefined' || bathrooms < minBaths) {
      minBaths = bathrooms
    }
    if (typeof maxBaths === 'undefined' || bathrooms > maxBaths) {
      maxBaths = bathrooms
    }
  })
  const { match } = dispatch(getRouteProps({ routes }))
  const pageType = getTraktorPageType({}, match, state)
  return {
    visiblePropertyIds,
    minBeds,
    maxBeds,
    minBaths,
    maxBaths,
    amenities,
    imageIds,
    imageCount,
    pageType,
    ...(activeListingsArr.length > 0 && { activeListings: activeListingsArr }),
    ...(inactiveListingsArr.length > 0 && { inactiveListings: inactiveListingsArr }),
  }
}
